import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import SntDialog from "@/components/SntDialog/SntDialog";
import SntCheckBox from "@/cleanup/components/SntCheckBox/SntCheckBox";
import commonClient from "@/apis/commonClient/commonClient";
import StringUtils from "@/utils/StringUtils";
import * as actions from "@/redux/actions";
import { LoginInfo } from "@/types/LoginInfo";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

interface TermOfUseProps {
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  loginInfo: LoginInfo;
}

const TermOfUse: React.FC<TermOfUseProps> = ({ isShow, setIsShow, loginInfo }) => {

  const dispatch = useDispatch();
  const [title, setTitle] = useState<string>(
    translate(LanguageKey.v41_title_terms_and_conditions_and_privacy_policies_key)
  );
  const [content, setContent] = useState<string>(
    translate(LanguageKey.v41_content_transit_terms_of_use_key)
  );
  const [agree, setAgree] = useState<string | JSX.Element | null>(null);
  const [agreeInfo, setAgreeInfo] = useState<string>(
    translate(LanguageKey.v41_info_agree_terms_and_conditions_key)
  );
  const [userAgree, setUserAgree] = useState<boolean>(false);

  useEffect(() => {
    const termsOfUseInfo = loginInfo.termsOfUseInfo;
    if (termsOfUseInfo) {
      setAgree(
        StringUtils.replaceStr(
          translate(LanguageKey.v41_agree_terms_and_conditions_key),
          termsOfUseInfo.url,
          termsOfUseInfo.privacyPolicyUrl
        )
      );
      if (termsOfUseInfo.state === "NEW") {
        setTitle(
          translate(LanguageKey.v41_title_terms_and_conditions_and_privacy_policies_key)
        );
        setContent(translate(LanguageKey.v41_content_never_signed_tou_key));
      } else if (termsOfUseInfo.state === "UPDATE") {
        setTitle(translate(LanguageKey.v41_title_update_terms_of_use_key));
        setContent(translate(LanguageKey.v41_content_update_terms_of_use_key));
        setAgree(
          <span style={{ textTransform: "uppercase" }}>
            {ReactHtmlParser(
              StringUtils.replaceStr(
                translate(LanguageKey.v41_agree_update_terms_of_use_key),
                termsOfUseInfo.url,
                termsOfUseInfo.privacyPolicyUrl
              )
            )}
          </span>
        );
        setAgreeInfo("");
      }
    }
         
  }, [loginInfo]);

  function onAccept(): void {
    commonClient.signToU().then(() => {
      if (loginInfo.termsOfUseInfo) {
        loginInfo.termsOfUseInfo.state = "OK";
        loginInfo.termsOfUseInfo.ok = true;
      }
      dispatch(actions.updateProfile(loginInfo));
      setIsShow(false);
    });
  }

  const mainContent = useMemo(() => {
    return (
      <>
        <div>{content}</div>
        <div className="col-xs-12" style={{ display: "flex" }}>
          <SntCheckBox checked={userAgree} onChange={(checked) => setUserAgree(checked)} />
          <div style={{ paddingLeft: "7px", paddingTop: "9px" }}>
            <div>{typeof agree === "string" ? ReactHtmlParser(agree) : agree}</div>
            <div className="small-info">{agreeInfo}</div>
            <label
              id="termsConditions"
              style={{
                display: "none",
                color: "#f68484",
              }}
            >
              {translate(LanguageKey.v41_valid_accept_terms_of_use_key)}
            </label>
          </div>
        </div>
      </>
    );
    // eslint-disable-next-line
  }, [isShow, userAgree, agree, agreeInfo, content]);

  return (
    <SntDialog
      isShow={isShow}
      onSave={() => onAccept()}
      isShowCloseButton={false}
      saveTxt={translate(LanguageKey.v41_accept_key)}
      isShowSaveButton={true}
      title={title}
    >
      {() => mainContent}
    </SntDialog>
  );
};

export default TermOfUse;
